// extracted by mini-css-extract-plugin
export default {"base":"vp_GFU1l","image":"vp_rxl_t","muted":"vp_KPKGZ"};